import type { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';

import type { SectionSlots } from '../lease-details.types';

export type SectionShellProps = {
  title?: string;
  subtitle?: string;
  slots?: SectionSlots;
  children: ReactNode;
};

export const SectionShell = ({ title, subtitle, slots, children }: SectionShellProps) => (
  <Stack direction="column" spacing={{ sm: 3, xs: 2 }}>
    {slots?.top}
    {(title || subtitle) && (
      <Stack>
        {title && (
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '24px',
            }}
          >
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography variant="helpertext" sx={{ fontSize: '14px', lineHeight: '22px' }}>
            {subtitle}
          </Typography>
        )}
      </Stack>
    )}
    {slots?.beforeFields}
    {children}
    {slots?.afterFields}
    {slots?.bottom}
  </Stack>
);
